import { Container, Grid, LinearProgress, Stack, Typography, Tabs, Tab, Box, Alert, Button } from "@mui/material";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { useContext, useEffect, useState } from "react";
import { CasUserContext } from "../../services/casUserContext";
import UsuarioService from "../../services/UsuarioService";
import AlertService from "../../services/AlertService";
import { ItinerarioForm } from "../../componentes/Itinerario/ItinerarioForm";
import ItinerarioService from "../../services/ItinerarioService";
import { SolicitudItinerarioDTO } from "../../interfaces/Itinerario/SolicitudItinerarioDTO";
import BusqSolicitudItinerarioProyTable from "../../componentes/Proyectos/BusqProySolicitudesItinerarioTable";
import { useNavigate, useParams } from "react-router-dom";
import { EstudianteActivo } from "../../componentes/EstudianteSAAC/EstudianteActivo";
import { EstudianteActivoDTO, VoidEstudianteActivoDTO } from "../../interfaces/SAAC/EstudianteActivoDTO";
import { SolicitudEstudianteItinerarioDTO, VoidSolicitudEstudianteItinerarioDTO } from "../../interfaces/Itinerario/SolicitudEstudianteItinerarioDTO";
import { InformesInvestigador, InitialInformesInvestigador } from "../../interfaces/Itinerario/InformesInvestigador";
import ProyectoService from "../../services/ProyectoService";
import { AyudTesisPeriodoDTO, VoidAyudTesisPeriodoDTO } from "../../interfaces/ayudantias/AyudTesisPeriodo";
import AyudantiaService from "../../services/AyudantiaService";
import { format } from "date-fns";
import { TablaInformePendiente } from "../../componentes/Proyectos/TablaInformePendientes";
import { PermisoDTO, VoidPermisoDTO } from "../../interfaces/ProyectosDTOS/PermisoDTO";
import { SinPermisoProyectoPage } from "../Error/SinPermisoProyecto";
import { PeriodoAcademicoDTO, VoidPeriodoAcademicoDTO } from "../../interfaces/SAAC/PeriodoAcademicoDTO";
import AcademicoService from "../../services/AcademicoService";

const alertaService = new AlertService();
const usuarioService = new UsuarioService();
const itinerioService = new ItinerarioService();
const academicoService = new AcademicoService();
const proyectoService = new ProyectoService();
const ayudantiaService = new AyudantiaService();

export const ItinerarioPage: React.FC<{}> = () => {
  const casUserContext = useContext(CasUserContext);
  const token = casUserContext.token;
  const user = casUserContext.userData;
  const navigate = useNavigate();
  const [auth, setAuth] = useState(false);
  const [ready, setReady] = useState(false);
  const [limpiar, setLimpiar] = useState(false);
  const [estudianteValido, setEstudianteValido] = useState(false);
  const [tabIndex, setTabIndex] = useState(0); // Estado para manejar la pestaña seleccionada
  const [solicitudes, setSolicitudes] = useState<Array<SolicitudItinerarioDTO>>([]);
  let [estudiante, setEstudiante] = useState<EstudianteActivoDTO>(VoidEstudianteActivoDTO());
  let [informes, setInformes] = useState<InformesInvestigador>(InitialInformesInvestigador());
  let [fechasAyu, setFechasAyu] = useState<AyudTesisPeriodoDTO>(VoidAyudTesisPeriodoDTO());
  let [permisoProyecto, setPermisoProyecto] = useState<PermisoDTO>(VoidPermisoDTO());
  const [periodoActivo, setPeriodoActivo] = useState<PeriodoAcademicoDTO>(VoidPeriodoAcademicoDTO());
  const { idProy } = useParams();

  const AUTORIZADOS = [142, 143, 144, 146];//["ANALISTA DE GESTIÓN DE PROYECTOS", "ADMINISTRADOR", "DIRECTOR"];

  useEffect(() => {
    const flag = usuarioService.authorizedByGroup(AUTORIZADOS, user.roles);
    setAuth(flag);
    if (flag) {
      const id = parseInt(idProy ?? '0', 10)
      verificarPermisoSobreProyecto();
      verificarInformesPendientes();
      fetchData(id);
      GetPeriodo();
      PeriodoItinerario();
      setReady(true);
    }
  }, [token]);

  const fetchData = async (id: number) => {
    try {
      await itinerioService.ListSolicitudesEstudiantesItinerarioByProyecto(token, id)
        .then((data) => {
          if (data.status.isSuccessfully) {
            setSolicitudes(data.listData);
          } else {
            setSolicitudes([]);
          }
        })
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const GetPeriodo = async () => {
    await academicoService.GetPeriodoAcademicoEnEjecucion(token)
      .then((data) => {
        setPeriodoActivo(data.data)
      })
      .catch((error) => console.error(error));
  };

  async function verificarInformesPendientes() {
    await proyectoService.InformesPendientesProyectosEnEjec(user.idinv, token)
      .then((data) => {
        //console.log(data.data);
        if (data.status.isSuccessfully) {
          setInformes(data.data);
        } else {
          setInformes(InitialInformesInvestigador());
        }
      })
      .catch((error) => {
        console.error(error)
      });
  }

  async function verificarPermisoSobreProyecto() {
    const id = parseInt(idProy ?? '0', 10)
    await proyectoService.ValidateEditProy(user.idpersona, id, token)
      .then((data) => {
        //console.log(data.data);
        if (data.status.isSuccessfully) {
          setPermisoProyecto(data.data);
        } else {
          setPermisoProyecto(VoidPermisoDTO());
        }
      })
      .catch((error) => {
        console.error(error)
      });
  }

  const PeriodoItinerario = async () => {
    try {
      await ayudantiaService.GetFechaAperturaCierreAyudTesis(token)
        .then((data) => {
          if (data.status.isSuccessfully) {
            setFechasAyu(data.data);
            //console.log(data.data);
          } else {
            setFechasAyu(VoidAyudTesisPeriodoDTO());
          }
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error('Error:', error);
    }
  };

  function DentroPeriodoItinerarias(): boolean {
    let bandera = false;
    const today = new Date();
    if (fechasAyu.estado === 1) {
      const fechaInicio = new Date(fechasAyu.fechaAperturaTesis);
      const fechaFin = new Date(fechasAyu.fechaCierreTesis);
      bandera = today >= fechaInicio && today <= fechaFin;
    }
    return bandera;
  }

  // Función para manejar el cambio de pestañas
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    limpiarForm();
  };

  const handleResponse = async (responseData: EstudianteActivoDTO) => {
    // Manejar la respuesta aquí
    setEstudiante(responseData);
    if (responseData.estudianteValido.length === 0) {
      setEstudianteValido(true);
      setLimpiar(true);
    }
  };

  const handleResponseForm = async (responseData: SolicitudEstudianteItinerarioDTO) => {
    // Manejar la respuesta aquí
    if (responseData.itinerario) {
      setEstudiante(VoidEstudianteActivoDTO());
      setEstudianteValido(false);
      setLimpiar(false);
      alertaService.alertaExito("éxito", "Se ha registrado su itinerario");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const limpiarForm = () => {
    // Manejar la respuesta aquí
    setEstudiante(VoidEstudianteActivoDTO());
    setEstudianteValido(false);
    setLimpiar(false);
  };

  const goToNavigation = (site: string) => {
    navigate(site)
  }

  return (
    <Container sx={{ mt: 5, mb: 4, border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2, // margen inferior para separar el encabezado del resto del contenido
        }}
      >
        {/* Título alineado a la izquierda */}
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#517ED3' }}>
          Itinerario Investigación
        </Typography>
        {/* Botón alineado a la derecha */}
        <Button variant="contained" color="primary" onClick={() => { goToNavigation('/Proyecto/proyectosAprobados') }}>
          Proyectos
        </Button>
      </Box>
      <br />
      {auth ?
        <>{ready ?
          <>
            {permisoProyecto.bandera ?
              <>
                {/* Componente de pestañas */}
                <Tabs value={tabIndex} onChange={handleTabChange} centered>
                  <Tab label="Formulario" />
                  <Tab label="Histórico de solicitudes" />
                </Tabs>
                {/* Contenido de las pestañas */}
                {tabIndex === 0 && (
                  <Box sx={{ mt: 4 }}>
                    <Grid container spacing={2}
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <Typography variant="h5" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: '#517ED3' }}>
                          Estudiantes para tomar materias de Investigación {periodoActivo.termino + "-" + periodoActivo.anio}
                        </Typography>
                        <Alert severity="info">El periodo de solicitud de itinerarios de investigación inicio {fechasAyu.fechaAperturaTesis ? format(new Date(fechasAyu.fechaAperturaTesis), 'dd/MMM/yyyy') : "Fecha no disponible"} y finaliza {fechasAyu.fechaCierreTesis ? format(new Date(fechasAyu.fechaCierreTesis), 'dd/MMM/yyyy') : "Fecha no disponible"}, fecha de Ecuador</Alert>
                      </Grid>
                      <Grid item xs={12}>
                        {DentroPeriodoItinerarias() ?
                          informes.pendiente ? <>
                            <Typography variant="body1" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%' }}>
                              Se encontraron informes pendientes:
                            </Typography>
                            <TablaInformePendiente informe={informes} />
                          </>
                            :
                            <>
                              <EstudianteActivo token={token} tipo="I" ocultarBoton={limpiar} onResponse={handleResponse} onClean={limpiarForm} />
                              <br />
                              {estudianteValido ?
                                <ItinerarioForm token={token} idProyecto={parseInt(idProy ?? '0', 10)} estudiante={estudiante} onResponse={handleResponseForm} SolicitudItinerario={VoidSolicitudEstudianteItinerarioDTO()} />
                                : <></>
                              }
                            </> :
                          <Alert severity="warning">Nos encontramos fuera del periodo de solicitud de itinerarios de investigación</Alert>
                        }
                      </Grid>
                    </Grid>
                  </Box>
                )}
                {tabIndex === 1 && (
                  <Box sx={{ mt: 4 }}>
                    <Grid container spacing={2}
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <Typography variant="h5" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: '#517ED3' }}>
                          Historial Solicitudes
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <BusqSolicitudItinerarioProyTable rowsPerPage={[5, 10, 25, 100]} data={solicitudes} token={token} periodoActivo={periodoActivo} fechasItinerario={fechasAyu} />
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </>
              : <SinPermisoProyectoPage />}
          </>
          :
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
            <LinearProgress color="secondary" />
          </Stack>}
        </>
        :
        <UnauthorizedPage />
      }
    </Container>
  );
}
